import Immutable from "immutable";
import * as types from "./constants";

const initialState = Immutable.fromJS({
  soloFilesFetching: false,
  soloFilesDidInvalidate: false,
  soloFilesToAnnotate: {},
  possibleForms: {},
  soloMatchedForms: {},
  soloCastsInFiles: {},
  soloFilesBeingAnnotated: [],
  soloFilesBeingSaved: [],
  soloSuccessfulAnnotations: [],
  soloAnnotationModalOpen: false,
  soloAnnotationModalCast: {},
  soloAnnotationModalForms: [],
  soloChartModalOpen: false,
  soloChartModalCast: {},
  soloChartDataFetching: false,
  soloChartData: [],
  soloAnnotationSnackbarOpen: false
});

function soloAnnotateReducer(state = initialState, action) {
  switch (action.type) {
    case types.SIGN_OUT_COMPLETE:
      return initialState;
    case types.WORKAREA_SET:
      return initialState;
    case types.ORGANIZATION_SET:
      return initialState;

    case types.SOLO_ANNOTATE_FILES_INVALIDATE:
      return state.merge({
        soloFilesDidInvalidate: true,
        soloFilesBeingAnnotated: [],
        soloCastsInFiles: {},
        possibleForms: {},
        soloMatchedForms: {}
      });

    case types.SOLO_ANNOTATE_FILES_FETCH_REQUEST:
      return state.set("soloFilesFetching", true);

    case types.SOLO_ANNOTATE_FILES_FETCH_SUCCESS:
      return state.merge({
        soloFilesFetching: false,
        soloFilesToAnnotate: action.payload.reduce(
          (R, x) => ({ ...R, [x.soloFilePk]: x }),
          {}
        )
      });

    case types.SOLO_ANNOTATE_FILES_FETCH_ERROR:
      return state.merge({
        soloFilesFetching: false,
        soloFilesDidInvalidate: true
      });

    case types.SOLO_ANNOTATE_UPDATE_FILE:
      return state.mergeIn(
        ["soloFilesToAnnotate", action.payload.soloFilePk.toString()],
        Immutable.fromJS(action.payload.update)
      );

    case types.SOLO_REMOVE_FILE_REQUEST:
      return state;

    case types.SOLO_REMOVE_FILE_SUCCESS:
      return state.withMutations(s =>
        s
          .update("soloFilesToAnnotate", x =>
            x.delete(action.payload.soloFilePk.toString())
          )
          .update("soloFilesBeingAnnotated", x =>
            x.toSet().delete(action.payload.soloFilePk)
          )
          .update("soloCastsInFiles", x =>
            x.delete(action.payload.soloFilePk.toString())
          )
      );

    case types.SOLO_REMOVE_FILE_ERROR:
      return state;

    case types.SOLO_ANNOTATE_CASTS_FETCH_REQUEST:
      return state;

    case types.SOLO_ANNOTATE_CASTS_FETCH_SUCCESS:
      return state.mergeDeep({
        possibleForms: action.payload.reduce(
          (R, x) => ({ ...R, [x.soloCastPk]: x.possibleForms }),
          {}
        ),
        soloMatchedForms: action.payload.reduce(
          (R, x) => ({ ...R, [x.soloCastPk]: x.soloMatchedForm }),
          {}
        ),
        /* ORIGINAL CODE
          soloCastsInFiles: Immutable.fromJS(action.payload)
          .map(x => x.delete("possibleForms").delete("soloMatchedForm"))
          .groupBy(x => x.get("soloFilePk").toString())
        */
        // soloCastsInFiles as object indexed by castpk, grouped by file pk (easier to access)
        soloCastsInFiles: Immutable.fromJS(
          action.payload.reduce((R, x) => ({ ...R, [x.soloCastPk]: x }), {})
        )
          .map(x => x.delete("possibleForms").delete("soloMatchedForm"))
          .groupBy(x => x.get("soloFilePk").toString())
        //
      });

    case types.SOLO_ANNOTATE_CASTS_FETCH_ERROR:
      return state.update("soloFilesBeingAnnotated", x => {
        if (action.meta) {
          return x.toSet().delete(action.meta.soloFilePk);
        }
        return x.toSet();
      });

    case types.SOLO_ANNOTATE_CASTS_SET_MATCHED_FORM:
      return state.setIn(
        ["soloMatchedForms", action.payload.soloCastPk.toString()],
        Immutable.fromJS(action.payload.soloMatchedForm)
      );

    case types.SOLO_ANNOTATE_CASTS_UPDATE_MATCHED_FORM:
      return state.mergeIn(
        ["soloMatchedForms", action.payload.soloCastPk.toString()],
        Immutable.fromJS(action.payload.update)
      );

    case types.SOLO_ANNOTATE_CASTS_UPDATE_CAST:
      return state.mergeIn(
        [
          "soloCastsInFiles",
          action.payload.soloFilePk.toString(),
          action.payload.soloCastPk.toString()
        ],
        Immutable.fromJS(action.payload.update)
      );

    case types.SOLO_ANNOTATE_FILES_REQUEST:
      return state.update("soloFilesBeingSaved", x =>
        x.toSet().add(action.payload.soloFilePk)
      );

    case types.SOLO_ANNOTATE_FILES_SUCCESS:
      return state.withMutations(s =>
        s
          .update("soloFilesBeingSaved", x =>
            x.toSet().delete(action.payload.soloFilePk)
          )
          .update("soloFilesBeingAnnotated", x =>
            x.toSet().delete(action.payload.soloFilePk)
          )
          .update("soloCastsInFiles", x =>
            x.delete(action.payload.soloFilePk.toString())
          )
          .update("soloFilesToAnnotate", x =>
            x.delete(action.payload.soloFilePk.toString())
          )
          .update("soloSuccessfulAnnotations", x =>
            x.toSet().add(action.payload.filename)
          )
      );

    case types.SOLO_ANNOTATE_FILES_ERROR:
      return state.update("soloFilesBeingSaved", x =>
        x.toSet().delete(action.meta.soloFilePk)
      );

    case types.SOLO_ANNOTATE_MODAL_OPEN:
      return state.set("soloAnnotationModalOpen", true);

    case types.SOLO_ANNOTATE_MODAL_CLOSE:
      return state.set("soloAnnotationModalOpen", false);

    case types.SOLO_ANNOTATE_MODAL_SET_CAST:
      return state.merge({ soloAnnotationModalCast: action.payload });

    case types.SOLO_ANNOTATE_MODAL_SET_FORMS:
      return state.merge({ soloAnnotationModalForms: action.payload });

    case types.SOLO_ANNOTATE_MODAL_SET_SELECTED:
      return state.merge({ soloAnnotationModalSelected: action.payload });

    case types.SOLO_CHART_MODAL_OPEN:
      return state.set("soloChartModalOpen", true);

    case types.SOLO_CHART_MODAL_CLOSE:
      return state.merge({
        soloChartModalOpen: false,
        soloChartModalCast: {},
        soloChartData: []
      });

    case types.SOLO_CHART_MODAL_SET_CAST:
      return state.merge({ soloChartModalCast: action.payload });

    case types.SOLO_CHART_MODAL_UPDATE_CAST:
      return state.mergeIn(
        ["soloChartModalCast"],
        Immutable.fromJS(action.payload)
      );

    case types.SOLO_CHART_DATA_FETCH_REQUEST:
      return state.set("soloChartDataFetching", true);

    case types.SOLO_CHART_DATA_FETCH_SUCCESS:
      return state.mergeDeep({
        soloChartDataFetching: false,
        soloChartData: action.payload
      });

    case types.SOLO_CHART_DATA_FETCH_ERROR:
      return state.merge({
        soloChartDataFetching: false,
        soloChartModalCast: {}
      });

    case types.SOLO_ANNOTATE_SNACKBAR_OPEN:
      return state.set("soloAnnotationSnackbarOpen", true);

    case types.SOLO_ANNOTATE_SNACKBAR_CLOSE:
      return state.merge({
        soloAnnotationSnackbarOpen: false,
        soloSuccessfulAnnotations: []
      });

    case types.SOLO_ANNOTATE_ADD_FILE_TO_ANNOTATE:
      return state.update("soloFilesBeingAnnotated", x =>
        x.toSet().add(action.payload.soloFilePk)
      );

    case types.SOLO_ANNOTATE_REMOVE_FILE_TO_ANNOTATE:
      return state.update("soloFilesBeingAnnotated", x =>
        x.toSet().delete(action.payload.soloFilePk)
      );

    default:
      return state;
  }
}

export default soloAnnotateReducer;
